import { FSharpRef, Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { Role_AllowedViewAs_335EB78D, UpdatedUser, UserState, Role_FromInt_Z524259A4, Role__ToInt, Role__ToDescription, Role as Role_1, User as User_1, S3UploadFile, Title_$reflection, Workplace_$reflection, Region_$reflection, User_$reflection } from "./Shared/SharedModels.jsx";
import { union_type, class_type, string_type, record_type, bool_type, array_type, option_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { ContextMsg, useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toArray as toArray_1, bind, map, defaultArg, orElse } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { Title3, CardFooter, Table, TableBody, TableCellLayout, TableCell, TableRow, Badge, Body1Strong, Divider, Avatar, Title1, CardHeader, Subtitle2, Card, Link, Switch, Caption1, Checkbox, Option, Dropdown, Label, Input, Field, DialogSurface, DialogBody, Text as Text$, Spinner, DialogActions, tokens, Image, DialogContent, DialogTitle, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { int32ToString, equals, createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { map as map_2, iterate, toArray, forAll, tryHead, take, length, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { BookClockRegular, LayerDiagonalPersonRegular, CheckmarkRegular, BookRegular, PersonPasskeyRegular, MailRegular, HatGraduationRegular, BriefcaseRegular, MapRegular, PersonRegular, ChevronRightRegular, SaveRegular, DismissRegular, ImageAddRegular, EditRegular } from "@fluentui/react-icons";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { length as length_1, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { tap, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "./fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { Title as Title_1, Workplace as Workplace_1, toastServerError, User } from "./ApiClient.jsx";
import { successToast, errorToast } from "./Toasts.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { isValidEmail, isValidName } from "./Shared/Validators.jsx";
import { join, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { isDigit } from "./fable_modules/fable-library-js.4.29.0/Char.js";
import { map as map_1, tryFind } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { Checkbox_toBool } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { tryParse } from "./fable_modules/fable-library-js.4.29.0/Int32.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";

class Model extends Record {
    constructor(User, Regions, Workplaces, Titles, IsFetchingUser, EditUserForm, ProfilePictureForm, AcknowledgedSensitiveChanges) {
        super();
        this.User = User;
        this.Regions = Regions;
        this.Workplaces = Workplaces;
        this.Titles = Titles;
        this.IsFetchingUser = IsFetchingUser;
        this.EditUserForm = EditUserForm;
        this.ProfilePictureForm = ProfilePictureForm;
        this.AcknowledgedSensitiveChanges = AcknowledgedSensitiveChanges;
    }
}

function Model_$reflection() {
    return record_type("UserProfile.Model", [], Model, () => [["User", option_type(User_$reflection())], ["Regions", array_type(Region_$reflection())], ["Workplaces", array_type(Workplace_$reflection())], ["Titles", array_type(Title_$reflection())], ["IsFetchingUser", bool_type], ["EditUserForm", option_type(User_$reflection())], ["ProfilePictureForm", ProfilePictureModel_$reflection()], ["AcknowledgedSensitiveChanges", bool_type]]);
}

class ProfilePictureModel extends Record {
    constructor(Image, File, IsSendingPicture) {
        super();
        this.Image = Image;
        this.File = File;
        this.IsSendingPicture = IsSendingPicture;
    }
}

function ProfilePictureModel_$reflection() {
    return record_type("UserProfile.ProfilePictureModel", [], ProfilePictureModel, () => [["Image", option_type(string_type)], ["File", option_type(class_type("Browser.Types.File"))], ["IsSendingPicture", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateUser", "UpdateRegions", "UpdateWorkplaces", "UpdateTitles", "SetUserIsFetched", "UpdateForm", "ResetForm", "UpdateProfilePictureForm", "AcknowledgeSensitiveChanges"];
    }
}

function Msg_$reflection() {
    return union_type("UserProfile.Msg", [], Msg, () => [[["Item", option_type(User_$reflection())]], [["Item", array_type(Region_$reflection())]], [["Item", array_type(Workplace_$reflection())]], [["Item", array_type(Title_$reflection())]], [], [["Item", User_$reflection()]], [], [["Item", ProfilePictureModel_$reflection()]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.User, msg.fields[0], model.Workplaces, model.Titles, model.IsFetchingUser, model.EditUserForm, model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        case 2:
            return new Model(model.User, model.Regions, msg.fields[0], model.Titles, model.IsFetchingUser, model.EditUserForm, model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        case 3:
            return new Model(model.User, model.Regions, model.Workplaces, msg.fields[0], model.IsFetchingUser, model.EditUserForm, model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        case 4:
            return new Model(model.User, model.Regions, model.Workplaces, model.Titles, false, model.EditUserForm, model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        case 5:
            return new Model(model.User, model.Regions, model.Workplaces, model.Titles, model.IsFetchingUser, msg.fields[0], model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        case 6:
            return new Model(model.User, model.Regions, model.Workplaces, model.Titles, model.IsFetchingUser, model.User, model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        case 7:
            return new Model(model.User, model.Regions, model.Workplaces, model.Titles, model.IsFetchingUser, model.EditUserForm, msg.fields[0], model.AcknowledgedSensitiveChanges);
        case 8:
            return new Model(model.User, model.Regions, model.Workplaces, model.Titles, model.IsFetchingUser, model.EditUserForm, model.ProfilePictureForm, msg.fields[0]);
        default: {
            const user = msg.fields[0];
            return new Model(user, model.Regions, model.Workplaces, model.Titles, false, user, model.ProfilePictureForm, model.AcknowledgedSensitiveChanges);
        }
    }
}

function init() {
    return new Model(undefined, [], [], [], true, undefined, new ProfilePictureModel(undefined, undefined, false), false);
}

function EditPictureDialog(editPictureDialogInputProps) {
    let elems_5, el_4, el_2, props_50, props_48, el_6, el_16, elems_2, elems_1, el_30, elems_4, el_20, el_18, el_28, name_4, name_6, elemsToUse;
    const dispatch = editPictureDialogInputProps.dispatch;
    const model = editPictureDialogInputProps.model;
    const user = editPictureDialogInputProps.user;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const hasStoredImage = orElse(user.ThumbnailUrl, user.ImageUrl) != null;
    const el_32 = Dialog;
    return createElement(el_32, createObj(ofArray([["open", patternInput_1[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_5 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, createObj(toList(delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["style", {
            paddingLeft: 0,
        }]), delay(() => {
            let el;
            return append(singleton(["icon", (el = EditRegular, createElement(el, {}))]), delay(() => append(singleton(["appearance", "transparent"]), delay(() => (hasStoredImage ? singleton(["children", "Rediger bilde"]) : singleton(["children", "Legg til bilde"]))))));
        }))))))))),
    })), (props_50 = singleton_1((props_48 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger profilbilde",
    })), (el_16 = DialogContent, createElement(el_16, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
        alignItems: "center",
    }], (elems_2 = [createElement("input", {
        id: "image-select-input",
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                const f = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg_1) => {
                    const matchValue = reader.result;
                    if (typeof matchValue === "string") {
                        const base64data = matchValue;
                        dispatch(new Msg(7, [new ProfilePictureModel(base64data, f, model.ProfilePictureForm.IsSendingPicture)]));
                    }
                });
                reader.readAsDataURL(f);
            }
        },
        style: {
            display: "none",
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    }], (elems_1 = toList(delay(() => {
        let el_8, el_14, elems, el_12;
        const matchValue_1 = model.ProfilePictureForm.Image;
        if (matchValue_1 != null) {
            const img = matchValue_1;
            return append(singleton((el_8 = Image, createElement(el_8, {
                shape: "circular",
                style: {
                    width: 250,
                    height: 250,
                },
                fit: "cover",
                src: img,
            }))), delay(() => {
                let el_10;
                return singleton((el_10 = Button, createElement(el_10, {
                    disabled: model.ProfilePictureForm.IsSendingPicture,
                    children: "Slett bilde",
                    size: "small",
                    onClick: (_arg_2) => {
                        dispatch(new Msg(7, [new ProfilePictureModel(undefined, undefined, model.ProfilePictureForm.IsSendingPicture)]));
                    },
                    appearance: "transparent",
                })));
            }));
        }
        else {
            return singleton((el_14 = Button, createElement(el_14, createObj(ofArray([["onClick", (_arg_3) => {
                document.getElementById("image-select-input").click();
            }], ["shape", "circular"], ["style", {
                height: 250,
                width: 250,
                borderStyle: "dashed",
                borderColor: tokens.colorBrandBackgroundStatic,
                borderWidth: 1,
            }], (elems = [(el_12 = ImageAddRegular, createElement(el_12, {
                fontSize: 48,
                primaryFill: tokens.colorBrandForeground2,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_30 = DialogActions, createElement(el_30, createObj(ofArray([["position", "end"], (elems_4 = [(el_20 = Button, createElement(el_20, {
        disabled: model.ProfilePictureForm.IsSendingPicture,
        icon: (el_18 = DismissRegular, createElement(el_18, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_4) => {
            dispatch(new Msg(7, [new ProfilePictureModel(undefined, undefined, false)]));
            setIsOpen(false);
        },
    })), (el_28 = Button, createElement(el_28, createObj(toList(delay(() => {
        let el_22;
        return append(!model.ProfilePictureForm.IsSendingPicture ? singleton(["icon", (el_22 = SaveRegular, createElement(el_22, {}))]) : empty(), delay(() => append(singleton(["appearance", "primary"]), delay(() => append(singleton(["iconPosition", "before"]), delay(() => append(singleton(["onClick", (_arg_5) => {
            let bind$0040_3;
            const matchValue_2 = model.ProfilePictureForm.File;
            if (matchValue_2 != null) {
                const f_1 = matchValue_2;
                dispatch(new Msg(7, [(bind$0040_3 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_3.Image, bind$0040_3.File, true))]));
                const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_6) => {
                    let MimeType;
                    let pr_1;
                    const pr = startAsPromise(User.UpdateProfilePicture((MimeType = f_1.type, new S3UploadFile(f_1.name, MimeType, _arg_6))));
                    pr_1 = (pr.then((res) => {
                        let bind$0040_6, bind$0040_5;
                        if (res.tag === 1) {
                            if (res.fields[0].tag === 1) {
                                errorToast(setCtx, "updateProfilePicS3Error", "Kunne ikke laste opp bilde", "", undefined);
                                dispatch(new Msg(7, [(bind$0040_6 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_6.Image, bind$0040_6.File, false))]));
                            }
                            else {
                                errorToast(setCtx, "updateProfilePicNotFoundError", "Kunne ikke laste opp bilde", "Fant ikke bruker", undefined);
                                dispatch(new Msg(7, [(bind$0040_5 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_5.Image, bind$0040_5.File, false))]));
                            }
                        }
                        else {
                            successToast(setCtx, `addProfilePic${user.Id}Success`, "Profilbilde oppdatert", "");
                            const newUserObject = new User_1(user.Id, user.KeycloakId, user.FirstName, user.LastName, user.State, user.Role, user.RealRole, user.Email, user.Phone, res.fields[0][0], res.fields[0][1], user.Workplace, user.Title, user.HasMaterialAccess, user.Inserted);
                            dispatch(new Msg(0, [newUserObject]));
                            setCtx(new ContextMsg(2, [newUserObject]));
                            dispatch(new Msg(7, [new ProfilePictureModel(undefined, undefined, false)]));
                            setIsOpen(false);
                        }
                    }));
                    void (pr_1.catch((ex) => {
                        let bind$0040_7;
                        dispatch(new Msg(7, [(bind$0040_7 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_7.Image, bind$0040_7.File, false))]));
                        toastServerError(setCtx, ex);
                    }));
                    return Promise.resolve();
                }))));
                void pr_2;
            }
        }]), delay(() => append(singleton(["disabled", (model.ProfilePictureForm.File == null) ? true : model.ProfilePictureForm.IsSendingPicture]), delay(() => {
            let elems_3;
            return singleton((elems_3 = toList(delay(() => {
                let el_24, el_26;
                return model.ProfilePictureForm.IsSendingPicture ? singleton((el_24 = Spinner, createElement(el_24, {
                    size: "tiny",
                }))) : singleton((el_26 = Text$, createElement(el_26, {
                    children: "Last opp",
                })));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_3))]));
        }))))))))));
    })))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (name_4 = DialogBody, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_48)),
    })))), (name_6 = DialogSurface, createElement(name_6, {
        children: reactApi.Children.toArray(Array.from(props_50)),
    })))], (elemsToUse = ((length(elems_5) <= 2) ? elems_5 : take(2, elems_5)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditUserDialog(editUserDialogInputProps) {
    let elems_25, el_4, el_2, el, props_126, props_124, el_6, el_72, elems_22, el_84, elems_24, el_76, el_74, el_82, name_26, name_28, elemsToUse;
    const dispatch = editUserDialogInputProps.dispatch;
    const model = editUserDialogInputProps.model;
    const form = editUserDialogInputProps.form;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsUpdating = patternInput_2[1];
    const isUpdating = patternInput_2[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_86 = Dialog;
    return createElement(el_86, createObj(ofArray([["open", patternInput_1[0]], ["onOpenChange", (_arg_2, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_25 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = EditRegular, createElement(el, {})),
            children: "Rediger",
            disabled: (model.EditUserForm == null) ? true : ((ctx.User.Id !== form.Id) && !equals(ctx.User.Role, new Role_1(1, []))),
        })),
    })), (props_126 = singleton_1((props_124 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger profilinstillinger",
    })), (el_72 = DialogContent, createElement(el_72, createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["gap", 10 + "px "]), delay(() => append(singleton(["alignItems", "start"]), delay(() => (isMobile ? singleton(["width", 100 + "%"]) : singleton(["width", 250])))))))))))))], (elems_22 = toList(delay(() => {
        let elems_1, el_11;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            width: 100 + "%",
            height: 70,
        }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Fornavn"]), delay(() => append(!isValidName(form.FirstName) ? append(isNullOrWhiteSpace(form.FirstName) ? singleton(["validationMessage", "Navn kan ikke være tomt"]) : singleton(["validationMessage", "Navn kan ikke inneholde tall/tegn"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
            let matchValue, el_8;
            return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
                maxLength: 250,
                value: form.FirstName,
                onChange: (_arg_3, value_1_11) => {
                    dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, value_1_11.value, form.LastName, form.State, form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, form.Title, form.HasMaterialAccess, form.Inserted)]));
                },
            }))]), (matchValue == null) ? defaultOf() : matchValue)]);
        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_3, el_16;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
                height: 70,
            }], (elems_3 = [(el_16 = Field, createElement(el_16, createObj(toList(delay(() => append(singleton(["label", "Etternavn"]), delay(() => append(!isValidName(form.LastName) ? append(isNullOrWhiteSpace(form.LastName) ? singleton(["validationMessage", "Navn kan ikke være tomt"]) : singleton(["validationMessage", "Navn kan ikke inneholde tall/tegn"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                let matchValue_1, el_13;
                return singleton(["children", (matchValue_1 = tryHead([(el_13 = Input, createElement(el_13, {
                    maxLength: 250,
                    value: form.LastName,
                    onChange: (_arg_4, value_1_17) => {
                        dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, value_1_17.value, form.State, form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, form.Title, form.HasMaterialAccess, form.Inserted)]));
                    },
                }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_5, el_21;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    width: 100 + "%",
                    height: 70,
                }], (elems_5 = [(el_21 = Field, createElement(el_21, createObj(toList(delay(() => append(singleton(["label", "Email"]), delay(() => append(!isValidEmail(form.Email) ? append(isNullOrWhiteSpace(form.Email) ? singleton(["validationMessage", "Email kan ikke være tomt"]) : singleton(["validationMessage", "Email er ugyldig"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                    let matchValue_2, el_18;
                    return singleton(["children", (matchValue_2 = tryHead([(el_18 = Input, createElement(el_18, {
                        maxLength: 250,
                        type: "email",
                        value: form.Email,
                        onChange: (_arg_5, value_1_23) => {
                            dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, form.Role, form.RealRole, value_1_23.value, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, form.Title, form.HasMaterialAccess, form.Inserted)]));
                        },
                    }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                    let elems_8, el_28;
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        width: 100 + "%",
                        height: 70,
                    }], (elems_8 = [(el_28 = Field, createElement(el_28, createObj(toList(delay(() => append(singleton(["label", "Tlf"]), delay(() => append(!(form.Phone.length === 8) ? singleton(["validationMessage", "Tlf krever 8 siffer"]) : empty(), delay(() => {
                        let matchValue_3, el_25, elems_6, el_23;
                        return singleton(["children", (matchValue_3 = tryHead([(el_25 = Input, createElement(el_25, {
                            maxLength: 250,
                            type: "tel",
                            placeholder: "12345678",
                            contentBefore: createElement("div", createObj(singleton_1((elems_6 = [(el_23 = Text$, createElement(el_23, {
                                children: "+47",
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])))),
                            maxLength: 8,
                            value: form.Phone,
                            onChange: (_arg_6, value_1_31) => {
                                const v_3 = value_1_31;
                                if (forAll(isDigit, v_3.value.split(""))) {
                                    dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, form.Role, form.RealRole, form.Email, v_3.value, form.ImageUrl, form.ThumbnailUrl, form.Workplace, form.Title, form.HasMaterialAccess, form.Inserted)]));
                                }
                            },
                        }))]), (matchValue_3 == null) ? defaultOf() : matchValue_3)]);
                    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let elems_12, el_30, elems_11, el_36, elems_10, el_40, el_38;
                        return append(singleton(createElement("div", createObj(ofArray([["style", {
                            width: 100 + "%",
                            display: "flex",
                            flexDirection: "column",
                        }], (elems_12 = [(el_30 = Label, createElement(el_30, {
                            children: "Arbeidsplass",
                        })), createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            gap: 5 + "px ",
                        }], (elems_11 = [(el_36 = Dropdown, createElement(el_36, createObj(ofArray([["style", {
                            minWidth: 200,
                            width: 100 + "%",
                        }], ["value", defaultArg(map((_arg_7) => _arg_7.Name, form.Workplace), "Ingen valgt")], ["selectedOptions", toArray([defaultArg(map((_arg_8) => _arg_8.Name, form.Workplace), "Ingen valgt")])], ["onOptionSelect", (_arg_9, value_1_35) => {
                            dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, bind((name_12) => tryFind((w) => (w.Name === name_12), model.Workplaces), value_1_35.optionText), form.Title, form.HasMaterialAccess, form.Inserted)]));
                        }], (elems_10 = toList(delay(() => map_1((workplace) => {
                            let elems_9, el_32;
                            const el_34 = Option;
                            return createElement(el_34, createObj(ofArray([["text", workplace.Name], (elems_9 = [(el_32 = Text$, createElement(el_32, {
                                children: workplace.Name,
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])));
                        }, model.Workplaces))), ["children", reactApi_1.Children.toArray(Array.from(elems_10))])])))), (el_40 = Button, createElement(el_40, {
                            icon: (el_38 = DismissRegular, createElement(el_38, {})),
                            appearance: "transparent",
                            disabled: form.Workplace == null,
                            onClick: (_arg_10) => {
                                dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, undefined, form.Title, form.HasMaterialAccess, form.Inserted)]));
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                            let elems_16, el_42, elems_15, el_48, elems_14, el_52, el_50;
                            return append(singleton(createElement("div", createObj(ofArray([["style", {
                                width: 100 + "%",
                                display: "flex",
                                flexDirection: "column",
                            }], (elems_16 = [(el_42 = Label, createElement(el_42, {
                                children: "Tittel",
                            })), createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                gap: 5 + "px ",
                            }], (elems_15 = [(el_48 = Dropdown, createElement(el_48, createObj(ofArray([["style", {
                                minWidth: 200,
                                width: 100 + "%",
                            }], ["value", defaultArg(map((_arg_11) => _arg_11.Name, form.Title), "Ingen valgt")], ["selectedOptions", toArray([defaultArg(map((_arg_12) => _arg_12.Name, form.Title), "Ingen valgt")])], ["onOptionSelect", (_arg_13, value_1_42) => {
                                dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, bind((name_17) => tryFind((t) => (t.Name === name_17), model.Titles), value_1_42.optionText), form.HasMaterialAccess, form.Inserted)]));
                            }], (elems_14 = toList(delay(() => map_1((title) => {
                                let elems_13, el_44;
                                const el_46 = Option;
                                return createElement(el_46, createObj(ofArray([["text", title.Name], (elems_13 = [(el_44 = Text$, createElement(el_44, {
                                    children: title.Name,
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])])));
                            }, model.Titles))), ["children", reactApi_1.Children.toArray(Array.from(elems_14))])])))), (el_52 = Button, createElement(el_52, {
                                icon: (el_50 = DismissRegular, createElement(el_50, {})),
                                appearance: "transparent",
                                disabled: form.Title == null,
                                onClick: (_arg_14) => {
                                    dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, undefined, form.HasMaterialAccess, form.Inserted)]));
                                },
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))), delay(() => {
                                let matchValue_4, u, u_1, el_56, text_4, el_54;
                                return append((matchValue_4 = model.User, (matchValue_4 != null) ? (((u = matchValue_4, !equals(u.Workplace, form.Workplace) ? true : (u.Email !== form.Email))) ? ((u_1 = matchValue_4, singleton((el_56 = Checkbox, createElement(el_56, {
                                    label: (text_4 = "Ved å endre arbeidsplass eller e-postadresse vil brukeren din bli satt som inaktiv og en administrator må godkjenne endringer. Godta endringer", (el_54 = Caption1, createElement(el_54, {
                                        children: text_4,
                                    }))),
                                    checked: model.AcknowledgedSensitiveChanges,
                                    onChange: (_arg_15, c_1) => {
                                        dispatch(new Msg(8, [Checkbox_toBool(c_1)]));
                                    },
                                }))))) : singleton(defaultOf())) : singleton(defaultOf())), delay(() => {
                                    let elems_20, el_65, matchValue_6, el_62, elems_18;
                                    return equals(ctx.User.Role, new Role_1(1, [])) ? append(singleton(createElement("div", createObj(ofArray([["style", {
                                        width: 100 + "%",
                                        height: 70,
                                    }], (elems_20 = [(el_65 = Field, createElement(el_65, {
                                        label: "Rolle",
                                        children: (matchValue_6 = tryHead([(el_62 = Dropdown, createElement(el_62, createObj(ofArray([["value", Role__ToDescription(form.Role)], ["selectedOptions", toArray([`${Role__ToInt(form.Role)}`])], ["onOptionSelect", (_arg_16, value_1_51) => {
                                            iterate((value_238) => {
                                                let matchValue_5;
                                                let outArg = 0;
                                                matchValue_5 = [tryParse(value_238, 511, false, 32, new FSharpRef(() => outArg, (v_5) => {
                                                    outArg = (v_5 | 0);
                                                })), outArg];
                                                if (matchValue_5[0]) {
                                                    dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.State, Role_FromInt_Z524259A4(matchValue_5[1]), form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, form.Title, form.HasMaterialAccess, form.Inserted)]));
                                                }
                                            }, toArray_1(value_1_51.optionValue));
                                        }], ["style", {
                                            minWidth: 200,
                                            width: 100 + "%",
                                        }], (elems_18 = toList(delay(() => map_1((r) => {
                                            let elems_17, el_58;
                                            const el_60 = Option;
                                            return createElement(el_60, createObj(ofArray([["text", Role__ToDescription(r)], ["value", `${Role__ToInt(r)}`], (elems_17 = [(el_58 = Text$, createElement(el_58, {
                                                children: Role__ToDescription(r),
                                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_17))])])));
                                        }, [new Role_1(1, []), new Role_1(0, []), new Role_1(2, []), new Role_1(3, [])]))), ["children", reactApi_1.Children.toArray(Array.from(elems_18))])]))))]), (matchValue_6 == null) ? defaultOf() : matchValue_6),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_20))])])))), delay(() => {
                                        let el_70;
                                        return singleton((el_70 = Field, createElement(el_70, createObj(toList(delay(() => append(singleton(["label", "Aktiv"]), delay(() => append((ctx.User.Id === form.Id) ? append(singleton(["validationMessage", "Kan ikke endres på egen konto"]), delay(() => singleton(["validationState", "warning"]))) : singleton(["validationState", "none"]), delay(() => {
                                            let matchValue_7, el_67;
                                            return singleton(["children", (matchValue_7 = tryHead([(el_67 = Switch, createElement(el_67, {
                                                checked: equals(form.State, new UserState(1, [])),
                                                disabled: ctx.User.Id === form.Id,
                                                onChange: (_arg_17, value_1_58) => {
                                                    dispatch(new Msg(5, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, value_1_58.checked ? (new UserState(1, [])) : (new UserState(2, [])), form.Role, form.RealRole, form.Email, form.Phone, form.ImageUrl, form.ThumbnailUrl, form.Workplace, form.Title, form.HasMaterialAccess, form.Inserted)]));
                                                },
                                            }))]), (matchValue_7 == null) ? defaultOf() : matchValue_7)]);
                                        }))))))))));
                                    })) : empty();
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_22))])])))), (el_84 = DialogActions, createElement(el_84, createObj(ofArray([["position", "end"], (elems_24 = [(el_76 = Button, createElement(el_76, {
        icon: (el_74 = DismissRegular, createElement(el_74, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_18) => {
            dispatch(new Msg(6, []));
            setIsOpen(false);
        },
    })), (el_82 = Button, createElement(el_82, createObj(toList(delay(() => {
        let el_78;
        return append(singleton(["icon", (el_78 = SaveRegular, createElement(el_78, {}))]), delay(() => append(singleton(["appearance", "primary"]), delay(() => append(singleton(["iconPosition", "before"]), delay(() => append(singleton(["onClick", (_arg_19) => {
            setIsUpdating(true);
            const pr = tap((res) => {
                try {
                    if (res.tag === 1) {
                        switch (res.fields[0].tag) {
                            case 1: {
                                errorToast(setCtx, `updateUser${form.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                                break;
                            }
                            case 2: {
                                errorToast(setCtx, `updateUser${form.Id}TitleNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig tittel", undefined);
                                break;
                            }
                            case 3: {
                                errorToast(setCtx, `updateUser${form.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                                break;
                            }
                            case 4: {
                                errorToast(setCtx, `updateUser${form.Id}InvalidEmail`, "Kunne ikke oppdatere bruker", "Ugyldig epos", undefined);
                                break;
                            }
                            case 5: {
                                errorToast(setCtx, `updateUser${form.Id}Internal`, "Kunne ikke oppdatere bruker", "", undefined);
                                break;
                            }
                            default:
                                errorToast(setCtx, `updateUser${form.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
                        }
                    }
                    else {
                        const newUser = res.fields[0];
                        setIsOpen(false);
                        dispatch(new Msg(0, [newUser]));
                        if (newUser.Id === ctx.User.Id) {
                            setCtx(new ContextMsg(2, [newUser]));
                        }
                    }
                }
                finally {
                    setIsUpdating(false);
                }
            }, startAsPromise(User.UpdateUser(form.Id, new UpdatedUser(form.FirstName, form.LastName, form.Email, form.Phone, form.State, form.Role, map((_arg) => _arg.Id, form.Workplace), map((_arg_1) => _arg_1.Id, form.Title)))));
            void (pr.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        }]), delay(() => append(singleton(["disabled", (((((defaultArg(map((user) => equals(user, form), model.User), false) ? true : !isValidName(form.FirstName)) ? true : !isValidName(form.LastName)) ? true : (defaultArg(map((s_2) => {
            if (s_2.Email !== form.Email) {
                return true;
            }
            else {
                return !equals(s_2.Workplace, form.Workplace);
            }
        }, model.User), false) && !model.AcknowledgedSensitiveChanges)) ? true : !isValidEmail(form.Email)) ? true : !(form.Phone.length === 8)) ? true : isUpdating]), delay(() => append(singleton(["children", "Lagre endringer"]), delay(() => {
            let elems_23, el_80;
            return isUpdating ? singleton((elems_23 = [(el_80 = Spinner, createElement(el_80, {
                size: "tiny",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_23))])) : empty();
        }))))))))))));
    })))))], ["children", reactApi_1.Children.toArray(Array.from(elems_24))])]))))]), (name_26 = DialogBody, createElement(name_26, {
        children: reactApi.Children.toArray(Array.from(props_124)),
    })))), (name_28 = DialogSurface, createElement(name_28, {
        children: reactApi.Children.toArray(Array.from(props_126)),
    })))], (elemsToUse = ((length(elems_25) <= 2) ? elems_25 : take(2, elems_25)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

class NavTileProps extends Record {
    constructor(Href, Title, Description, Icon, Accent, AccentBg) {
        super();
        this.Href = Href;
        this.Title = Title;
        this.Description = Description;
        this.Icon = Icon;
        this.Accent = Accent;
        this.AccentBg = AccentBg;
    }
}

function NavTileProps_$reflection() {
    return record_type("UserProfile.NavTileProps", [], NavTileProps, () => [["Href", string_type], ["Title", string_type], ["Description", string_type], ["Icon", class_type("Fable.React.ReactElement")], ["Accent", string_type], ["AccentBg", string_type]]);
}

function NavTile(props) {
    let elems_4, el_6, elems_3, elems_2, elems_1, el, el_2, el_4;
    const el_8 = Link;
    return createElement(el_8, createObj(ofArray([["href", props.Href], ["style", {
        textDecoration: "none",
        color: tokens.colorNeutralForeground1,
        display: "block",
        borderRadius: 8,
    }], (elems_4 = [(el_6 = Card, createElement(el_6, createObj(ofArray([["selected", false], ["style", {
        cursor: "pointer",
        padding: 0,
        height: 100 + "%",
        minHeight: 140 + "px",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 16 + "px ",
        padding: ((22 + "px") + " ") + (24 + "px"),
        height: 100 + "%",
    }], (elems_2 = [createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: 28,
            backgroundColor: props.AccentBg,
            color: props.Accent,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
        },
        children: reactApi.Children.toArray([props.Icon]),
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 4 + "px ",
        flexGrow: 1,
        minWidth: 0,
    }], (elems_1 = [(el = Subtitle2, createElement(el, {
        style: {
            color: tokens.colorNeutralForeground1,
        },
        children: props.Title,
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: props.Description,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_4 = ChevronRightRegular, createElement(el_4, {
        fontSize: 24,
        style: {
            color: tokens.colorNeutralForeground3,
            flexShrink: 0,
        },
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
}

function MobileProfileRow(icon, label, value) {
    let elems_2, elems_1, el;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 12 + "px ",
        paddingTop: 12,
        paddingBottom: 12,
        borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3,
    }], (elems_2 = [createElement("div", {
        style: {
            flexShrink: 0,
            color: tokens.colorNeutralForeground3,
            marginTop: 2,
        },
        children: reactApi.Children.toArray([icon]),
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        flexGrow: 1,
        gap: 2 + "px ",
    }], (elems_1 = [(el = Caption1, createElement(el, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: label,
    })), value], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function AboutUser(aboutUserInputProps) {
    let elems_12;
    const userId = aboutUserInputProps.userId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const dependencies = [userId];
    reactApi.useEffect(() => {
        let pr_1;
        const pr = startAsPromise(User.GetUser(userId));
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                dispatch(new Msg(4, []));
            }
            else {
                dispatch(new Msg(0, [res.fields[0]]));
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
    }, dependencies);
    useEffectOnce(() => {
        let pr_7;
        const pr_6 = startAsPromise(Workplace_1.GetEnabledWorkplaces());
        pr_7 = (pr_6.then((res_3) => {
            if (res_3.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Kunne ikke hente arbeidsplasser", "Noe gikk galt", undefined);
            }
            else {
                dispatch(new Msg(2, [res_3.fields[0]]));
            }
        }));
        void (pr_7.catch((ex_3) => {
            toastServerError(setCtx, ex_3);
        }));
        let pr_9;
        const pr_8 = startAsPromise(Title_1.GetAllTitles());
        pr_9 = (pr_8.then((res_4) => {
            if (res_4.tag === 1) {
                errorToast(setCtx, "fetchTitlesError", "Kunne ikke hente titler", "Noe gikk galt", undefined);
            }
            else {
                dispatch(new Msg(3, [res_4.fields[0]]));
            }
        }));
        void (pr_9.catch((ex_4) => {
            toastServerError(setCtx, ex_4);
        }));
        if (ctx.User.Id === userId) {
            dispatch(new Msg(0, [ctx.User]));
        }
    });
    const matchValue = model_1.User;
    if (matchValue != null) {
        const user_1 = matchValue;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 20 + "px ",
        }], (elems_12 = toList(delay(() => {
            let el_164, elems_8;
            return append(singleton((el_164 = Card, createElement(el_164, createObj(ofArray([["style", createObj(toList(delay(() => (!isMobile ? singleton(["maxWidth", 70 + "rem"]) : empty()))))], (elems_8 = toList(delay(() => {
                let el_8, elems, elems_1, el_6;
                return append(singleton((el_8 = CardHeader, createElement(el_8, {
                    header: createElement("div", createObj(ofArray([["style", {
                        alignItems: "flex-start",
                        display: "flex",
                        flexDirection: "column",
                    }], (elems = toList(delay(() => {
                        let el_4;
                        return append(singleton((el_4 = Title1, createElement(el_4, {
                            weight: "semibold",
                            children: `${user_1.FirstName} ${user_1.LastName}`,
                        }))), delay(() => ((userId === ctx.User.Id) ? singleton(createElement(EditPictureDialog, {
                            user: user_1,
                            model: model_1,
                            dispatch: dispatch,
                        })) : empty())));
                    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))),
                    image: createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }], (elems_1 = [(el_6 = Avatar, createElement(el_6, {
                        name: `${user_1.FirstName} ${user_1.LastName}`,
                        size: 96,
                        color: "colorful",
                        image: {
                            src: defaultArg(orElse(user_1.ThumbnailUrl, user_1.ImageUrl), ""),
                        },
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
                }))), delay(() => {
                    let el_10;
                    return append(singleton((el_10 = Divider, createElement(el_10, {}))), delay(() => {
                        let elems_4, props_228, props_226, name_18, name_20;
                        return append(isMobile ? singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            padding: ((0 + "px ") + 12) + "px",
                        }], (elems_4 = toList(delay(() => {
                            let el_12, el_14;
                            return append(singleton(MobileProfileRow((el_12 = PersonRegular, createElement(el_12, {})), "Navn", (el_14 = Body1Strong, createElement(el_14, {
                                children: `${user_1.FirstName} ${user_1.LastName}`,
                            })))), delay(() => {
                                let el_16, el_18, matchValue_1;
                                return append(singleton(MobileProfileRow((el_16 = MapRegular, createElement(el_16, {})), "Region", (el_18 = Body1Strong, createElement(el_18, {
                                    children: (matchValue_1 = user_1.Workplace, (matchValue_1 == null) ? "-" : matchValue_1.Region.Name),
                                })))), delay(() => {
                                    let el_20, el_22, matchValue_2;
                                    return append(singleton(MobileProfileRow((el_20 = BriefcaseRegular, createElement(el_20, {})), "Arbeidsplass", (el_22 = Body1Strong, createElement(el_22, {
                                        children: (matchValue_2 = user_1.Workplace, (matchValue_2 == null) ? "-" : matchValue_2.Name),
                                    })))), delay(() => {
                                        let el_24, el_26, matchValue_3;
                                        return append(singleton(MobileProfileRow((el_24 = HatGraduationRegular, createElement(el_24, {})), "Tittel", (el_26 = Body1Strong, createElement(el_26, {
                                            children: (matchValue_3 = user_1.Title, (matchValue_3 == null) ? "-" : matchValue_3.Name),
                                        })))), delay(() => {
                                            let el_28, el_30;
                                            return append(singleton(MobileProfileRow((el_28 = MailRegular, createElement(el_28, {})), "Email", (el_30 = Body1Strong, createElement(el_30, {
                                                children: user_1.Email,
                                                style: {
                                                    wordBreak: "break-all",
                                                },
                                            })))), delay(() => {
                                                let el_32, el_34;
                                                return append(singleton(MobileProfileRow((el_32 = PersonPasskeyRegular, createElement(el_32, {})), "Rolle", (el_34 = Body1Strong, createElement(el_34, {
                                                    children: Role__ToDescription(user_1.Role),
                                                })))), delay(() => {
                                                    let el_36, el_40, elems_2, el_38, el_44, elems_3, el_42;
                                                    return equals(ctx.User.Role, new Role_1(1, [])) ? singleton(MobileProfileRow((el_36 = BookRegular, createElement(el_36, {})), "Materialtilgang", user_1.HasMaterialAccess ? ((el_40 = Badge, createElement(el_40, createObj(ofArray([["appearance", "tint"], ["color", "success"], (elems_2 = [(el_38 = Text$, createElement(el_38, {
                                                        children: "Ja",
                                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))) : ((el_44 = Badge, createElement(el_44, createObj(ofArray([["appearance", "tint"], ["color", "danger"], (elems_3 = [(el_42 = Text$, createElement(el_42, {
                                                        children: "Nei",
                                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))))) : empty();
                                                }));
                                            }));
                                        }));
                                    }));
                                }));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : singleton((props_228 = singleton_1((props_226 = toList(delay(() => {
                            let el_60, el_52, el_50, el_46, el_48, el_58, el_56, el_54;
                            return append(singleton((el_60 = TableRow, createElement(el_60, {
                                children: ofArray([(el_52 = TableCell, createElement(el_52, {
                                    children: singleton_1((el_50 = TableCellLayout, createElement(el_50, {
                                        media: (el_46 = PersonRegular, createElement(el_46, {})),
                                        children: singleton_1((el_48 = Text$, createElement(el_48, {
                                            children: "Navn",
                                        }))),
                                    }))),
                                })), (el_58 = TableCell, createElement(el_58, {
                                    children: singleton_1((el_56 = TableCellLayout, createElement(el_56, {
                                        children: singleton_1((el_54 = Text$, createElement(el_54, {
                                            children: `${user_1.FirstName} ${user_1.LastName}`,
                                        }))),
                                    }))),
                                }))]),
                            }))), delay(() => {
                                let el_76, el_68, el_66, el_62, el_64, el_74, props_101, name_6;
                                return append(singleton((el_76 = TableRow, createElement(el_76, {
                                    children: ofArray([(el_68 = TableCell, createElement(el_68, {
                                        children: singleton_1((el_66 = TableCellLayout, createElement(el_66, {
                                            media: (el_62 = MapRegular, createElement(el_62, {})),
                                            children: singleton_1((el_64 = Text$, createElement(el_64, {
                                                children: "Region",
                                            }))),
                                        }))),
                                    })), (el_74 = TableCell, createElement(el_74, {
                                        children: singleton_1((props_101 = toList(delay(() => {
                                            let el_72, el_70;
                                            const matchValue_4 = user_1.Workplace;
                                            return (matchValue_4 == null) ? singleton((el_72 = Text$, createElement(el_72, {
                                                children: "-",
                                            }))) : singleton((el_70 = Text$, createElement(el_70, {
                                                children: `${matchValue_4.Region.Name}`,
                                            })));
                                        })), (name_6 = TableCellLayout, createElement(name_6, {
                                            children: reactApi.Children.toArray(Array.from(props_101)),
                                        })))),
                                    }))]),
                                }))), delay(() => {
                                    let el_92, el_84, el_82, el_78, el_80, el_90, props_124, name_8;
                                    return append(singleton((el_92 = TableRow, createElement(el_92, {
                                        children: ofArray([(el_84 = TableCell, createElement(el_84, {
                                            children: singleton_1((el_82 = TableCellLayout, createElement(el_82, {
                                                media: (el_78 = BriefcaseRegular, createElement(el_78, {})),
                                                children: singleton_1((el_80 = Text$, createElement(el_80, {
                                                    children: "Arbeidsplass",
                                                }))),
                                            }))),
                                        })), (el_90 = TableCell, createElement(el_90, {
                                            children: singleton_1((props_124 = toList(delay(() => {
                                                let el_88, el_86;
                                                const matchValue_5 = user_1.Workplace;
                                                return (matchValue_5 == null) ? singleton((el_88 = Text$, createElement(el_88, {
                                                    children: "-",
                                                }))) : singleton((el_86 = Text$, createElement(el_86, {
                                                    children: `${matchValue_5.Name}`,
                                                })));
                                            })), (name_8 = TableCellLayout, createElement(name_8, {
                                                children: reactApi.Children.toArray(Array.from(props_124)),
                                            })))),
                                        }))]),
                                    }))), delay(() => {
                                        let el_108, el_100, el_98, el_94, el_96, el_106, props_147, name_10;
                                        return append(singleton((el_108 = TableRow, createElement(el_108, {
                                            children: ofArray([(el_100 = TableCell, createElement(el_100, {
                                                children: singleton_1((el_98 = TableCellLayout, createElement(el_98, {
                                                    media: (el_94 = HatGraduationRegular, createElement(el_94, {})),
                                                    children: singleton_1((el_96 = Text$, createElement(el_96, {
                                                        children: "Tittel",
                                                    }))),
                                                }))),
                                            })), (el_106 = TableCell, createElement(el_106, {
                                                children: singleton_1((props_147 = toList(delay(() => {
                                                    let el_104, el_102;
                                                    const matchValue_6 = user_1.Title;
                                                    return (matchValue_6 == null) ? singleton((el_104 = Text$, createElement(el_104, {
                                                        children: "-",
                                                    }))) : singleton((el_102 = Text$, createElement(el_102, {
                                                        children: `${matchValue_6.Name}`,
                                                    })));
                                                })), (name_10 = TableCellLayout, createElement(name_10, {
                                                    children: reactApi.Children.toArray(Array.from(props_147)),
                                                })))),
                                            }))]),
                                        }))), delay(() => {
                                            let el_122, el_116, el_114, el_110, el_112, el_120, props_168, el_118, name_12;
                                            return append(singleton((el_122 = TableRow, createElement(el_122, {
                                                children: ofArray([(el_116 = TableCell, createElement(el_116, {
                                                    children: singleton_1((el_114 = TableCellLayout, createElement(el_114, {
                                                        media: (el_110 = MailRegular, createElement(el_110, {})),
                                                        children: singleton_1((el_112 = Text$, createElement(el_112, {
                                                            children: "Email",
                                                        }))),
                                                    }))),
                                                })), (el_120 = TableCell, createElement(el_120, {
                                                    children: singleton_1((props_168 = singleton_1((el_118 = Text$, createElement(el_118, {
                                                        children: user_1.Email,
                                                    }))), (name_12 = TableCellLayout, createElement(name_12, {
                                                        children: reactApi.Children.toArray(Array.from(props_168)),
                                                    })))),
                                                }))]),
                                            }))), delay(() => {
                                                let el_136, el_130, el_128, el_124, el_126, el_134, props_189, el_132, name_14;
                                                return append(singleton((el_136 = TableRow, createElement(el_136, {
                                                    children: ofArray([(el_130 = TableCell, createElement(el_130, {
                                                        children: singleton_1((el_128 = TableCellLayout, createElement(el_128, {
                                                            media: (el_124 = PersonPasskeyRegular, createElement(el_124, {})),
                                                            children: singleton_1((el_126 = Text$, createElement(el_126, {
                                                                children: "Rolle",
                                                            }))),
                                                        }))),
                                                    })), (el_134 = TableCell, createElement(el_134, {
                                                        children: singleton_1((props_189 = singleton_1((el_132 = Text$, createElement(el_132, {
                                                            children: Role__ToDescription(user_1.Role),
                                                        }))), (name_14 = TableCellLayout, createElement(name_14, {
                                                            children: reactApi.Children.toArray(Array.from(props_189)),
                                                        })))),
                                                    }))]),
                                                }))), delay(() => {
                                                    let el_156, el_144, el_142, el_138, el_140, el_154, props_218, name_16;
                                                    return equals(ctx.User.Role, new Role_1(1, [])) ? singleton((el_156 = TableRow, createElement(el_156, {
                                                        children: ofArray([(el_144 = TableCell, createElement(el_144, {
                                                            children: singleton_1((el_142 = TableCellLayout, createElement(el_142, {
                                                                media: (el_138 = BookRegular, createElement(el_138, {})),
                                                                children: singleton_1((el_140 = Text$, createElement(el_140, {
                                                                    children: "Materialtilgang",
                                                                }))),
                                                            }))),
                                                        })), (el_154 = TableCell, createElement(el_154, {
                                                            children: singleton_1((props_218 = toList(delay(() => {
                                                                let el_148, elems_5, el_146, el_152, elems_6, el_150;
                                                                return user_1.HasMaterialAccess ? singleton((el_148 = Badge, createElement(el_148, createObj(ofArray([["appearance", "tint"], ["color", "success"], (elems_5 = [(el_146 = Text$, createElement(el_146, {
                                                                    children: "Ja",
                                                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : singleton((el_152 = Badge, createElement(el_152, createObj(ofArray([["appearance", "tint"], ["color", "danger"], (elems_6 = [(el_150 = Text$, createElement(el_150, {
                                                                    children: "Nei",
                                                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))));
                                                            })), (name_16 = TableCellLayout, createElement(name_16, {
                                                                children: reactApi.Children.toArray(Array.from(props_218)),
                                                            })))),
                                                        }))]),
                                                    }))) : empty();
                                                }));
                                            }));
                                        }));
                                    }));
                                }));
                            }));
                        })), (name_18 = TableBody, createElement(name_18, {
                            children: reactApi.Children.toArray(Array.from(props_226)),
                        })))), (name_20 = Table, createElement(name_20, {
                            children: reactApi.Children.toArray(Array.from(props_228)),
                        })))), delay(() => {
                            let el_162, elems_7;
                            return singleton((el_162 = CardFooter, createElement(el_162, createObj(ofArray([["style", {
                                justifyContent: "end",
                            }], (elems_7 = toList(delay(() => {
                                let el_160, el_158;
                                const matchValue_7 = model_1.EditUserForm;
                                if (matchValue_7 != null) {
                                    const form = matchValue_7;
                                    return singleton(createElement(EditUserDialog, {
                                        form: form,
                                        model: model_1,
                                        dispatch: dispatch,
                                    }));
                                }
                                else {
                                    return singleton((el_160 = Button, createElement(el_160, {
                                        icon: (el_158 = EditRegular, createElement(el_158, {})),
                                        iconPosition: "before",
                                        children: "Rediger",
                                        disabled: true,
                                    })));
                                }
                            })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))));
                        }));
                    }));
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))), delay(() => {
                let allowed, el_178, elems_10, el_170, el_166, el_168, elems_9;
                return append((userId === ctx.User.Id) ? ((allowed = Role_AllowedViewAs_335EB78D(user_1.RealRole), (length_1(allowed) > 1) ? singleton((el_178 = Card, createElement(el_178, createObj(ofArray([["style", createObj(toList(delay(() => (!isMobile ? singleton(["maxWidth", 70 + "rem"]) : empty()))))], (elems_10 = [(el_170 = CardHeader, createElement(el_170, {
                    header: (el_166 = Title3, createElement(el_166, {
                        weight: "semibold",
                        children: "Bytt rolle",
                    })),
                    description: (el_168 = Caption1, createElement(el_168, {
                        children: (`Du er ${Role__ToDescription(user_1.RealRole)}. `) + "Du kan velge å se appen som en lavere rolle for å oppleve hvordan den ser ut for andre brukere.",
                    })),
                })), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8 + "px ",
                    padding: ((((((0 + "px ") + 12) + "px ") + 12) + "px ") + 12) + "px",
                }], (elems_9 = toList(delay(() => map_2((role) => {
                    const el_176 = Button;
                    return createElement(el_176, createObj(toList(delay(() => append(equals(user_1.Role, role) ? singleton(["appearance", "primary"]) : singleton(["appearance", "outline"]), delay(() => {
                        let el_172, el_174;
                        return append(singleton(["icon", equals(user_1.Role, role) ? ((el_172 = CheckmarkRegular, createElement(el_172, {}))) : ((el_174 = PersonRegular, createElement(el_174, {})))]), delay(() => append(singleton(["children", Role__ToDescription(role)]), delay(() => append(singleton(["disabled", equals(user_1.Role, role)]), delay(() => singleton(["onClick", (_arg_2) => {
                            let pr_3;
                            const pr_2 = startAsPromise(User.SetActiveRole(equals(role, user_1.RealRole) ? undefined : role));
                            pr_3 = (pr_2.then((res_1) => {
                                if (res_1.tag === 1) {
                                    if (res_1.fields[0].tag === 1) {
                                        errorToast(setCtx, "switchActiveRoleInternal", "Kan ikke bytte rolle", "", undefined);
                                    }
                                    else {
                                        errorToast(setCtx, "switchActiveRoleNotAllowed", "Kan ikke bytte rolle", "Du har ikke tilgang til denne rollen", undefined);
                                    }
                                }
                                else {
                                    const user = res_1.fields[0];
                                    setCtx(new ContextMsg(2, [user]));
                                    dispatch(new Msg(0, [user]));
                                }
                            }));
                            void (pr_3.catch((ex_1) => {
                                toastServerError(setCtx, ex_1);
                            }));
                        }])))))));
                    }))))));
                }, allowed))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])]))))) : empty())) : empty(), delay(() => {
                    let elems_11, el_180, el_182;
                    return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "grid"]), delay(() => append(isMobile ? singleton(["gridTemplateColumns", join(" ", [1 + "fr"])]) : singleton(["gridTemplateColumns", join(" ", [1 + "fr", 1 + "fr"])]), delay(() => append(singleton(["gap", 12 + "px "]), delay(() => (!isMobile ? singleton(["maxWidth", 70 + "rem"]) : empty()))))))))))], (elems_11 = [createElement(NavTile, new NavTileProps(RouterModule_encodeParts(ofArray(["bruker", int32ToString(userId), "fremdrift"]), 1), "Fremdrift", "Brukerens læringsløp, nivåer og fullførte oppgaver.", (el_180 = LayerDiagonalPersonRegular, createElement(el_180, {
                        fontSize: 28,
                    })), tokens.colorBrandForeground1, tokens.colorBrandBackground2)), createElement(NavTile, new NavTileProps(RouterModule_encodeParts(ofArray(["bruker", int32ToString(userId), "historikk"]), 1), "Kurshistorikk", "Arrangement brukeren har deltatt på og godkjente oppgaver.", (el_182 = BookClockRegular, createElement(el_182, {
                        fontSize: 28,
                    })), tokens.colorPaletteBrassForeground2, tokens.colorPaletteBrassBackground2))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
    }
    else if (model_1.IsFetchingUser) {
        const el = Spinner;
        return createElement(el, {});
    }
    else {
        const el_2 = Title3;
        return createElement(el_2, {
            children: "Denne brukeren finnes ikke",
        });
    }
}

//# sourceMappingURL=UserProfile.jsx.map
